/**
 * Role guards are never the user's problem.
 *
 * A family writer hitting a commerce route, or a non-owner hitting `/api/family/*`,
 * means the UI failed to hide something. Toasting "this account is managed by the
 * account owner" at them is noise — fix the gating instead. The axios interceptor
 * swallows these and resolves to null, so callers keep their empty-state handling.
 */
export const SILENT_ERROR_CODES = new Set(['FORBIDDEN_FAMILY_WRITER', 'FORBIDDEN_NOT_OWNER'])

/** Reads the backend's machine-readable `code` off an error response body. */
export const isSilentRoleError = (data: unknown): boolean => {
  if (typeof data !== 'object' || data === null) return false
  const code = (data as { code?: unknown }).code
  return typeof code === 'string' && SILENT_ERROR_CODES.has(code)
}
